import axios from '@/axios.js'

export default {
  addPdfTemplate({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/a/pdf-templates", item)
        .then((response) => {
          commit('ADD_PDF_TEMPLATE', Object.assign(item, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updatePdfTemplate({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put("/a/pdf-templates/" + item.id, item)
        .then((response) => {
          commit('UPDATE_PDF_TEMPLATE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchPdfTemplates ({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/a/pdf-templates', {
        params: payload
      })
        .then((response) => {
          commit('SET_PDF_TEMPLATES', response.data)
          commit('SET_PAGINATION', {
            currentPage: parseInt(response.headers['x-pagination-page']),
            totalPage: parseInt(response.headers['x-pagination-page-count']),
            pageTotal: parseInt(response.headers['x-pagination-count']),
            totalItem: parseInt(response.headers['x-pagination-total']),
          })

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchPdfTemplate (context, PdfTemplateId) {
    return new Promise((resolve, reject) => {
      axios.get(`/a/pdf-templates/${PdfTemplateId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
